class LCGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-lc-thumb]');
      if (!button) return;
      const index = button.dataset.lcThumb;
      this.querySelectorAll('[data-lc-slide]').forEach((slide) => {
        const selected = slide.dataset.lcSlide === index;
        slide.hidden = !selected;
        slide.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-lc-thumb]').forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb === button)));
    });
  }
}
if (!customElements.get('lc-gallery')) customElements.define('lc-gallery', LCGallery);
document.addEventListener('click', (event) => {
  if (event.target.closest('.lc-mobile-nav-panel a')) {
    event.target.closest('details').open = false;
  } else if (!event.target.closest('.lc-mobile-nav')) {
    document.querySelectorAll('.lc-mobile-nav[open]').forEach((nav) => { nav.open = false; });
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.lc-mobile-nav[open]').forEach((nav) => {
    nav.open = false; nav.querySelector('summary').focus();
  });
});
